module.exports = __webpack_public_path__ + "static/media/Cocina.f0cdf7b0.jpg";